export class GetDataCatalogNamespaceResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "DataCatalogNamespace",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogNamespaceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
